import { render } from "./SectionSeparatorWrapper.vue?vue&type=template&id=5e3ee302&scoped=true"
import script from "./SectionSeparatorWrapper.vue?vue&type=script&lang=js"
export * from "./SectionSeparatorWrapper.vue?vue&type=script&lang=js"

import "./SectionSeparatorWrapper.vue?vue&type=style&index=0&id=5e3ee302&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3ee302"]])

export default __exports__